var map = {
	"./deep.png": 74057,
	"./kardiologija/MSD.jpg": 45932,
	"./kardiologija/PHSerbia.jpg": 69024,
	"./logo.png": 20678,
	"./no-image-icon.png": 68558,
	"./reumatologija/logo_MSD.jpg": 97003,
	"./reumatologija/logo_abbvie.png": 84,
	"./reumatologija/logo_pfizer.png": 52261,
	"./reumatologija/logo_roc.png": 17083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;